import { render } from "./UnitBoxComponent.vue?vue&type=template&id=9640ea22&scoped=true"
import script from "./UnitBoxComponent.vue?vue&type=script&lang=js"
export * from "./UnitBoxComponent.vue?vue&type=script&lang=js"

import "./UnitBoxComponent.vue?vue&type=style&index=0&id=9640ea22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9640ea22"]])

export default __exports__